import { render, staticRenderFns } from "./boxList.vue?vue&type=template&id=5a749891&scoped=true"
import script from "./boxList.vue?vue&type=script&lang=js"
export * from "./boxList.vue?vue&type=script&lang=js"
import style0 from "./boxList.vue?vue&type=style&index=0&id=5a749891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a749891",
  null
  
)

export default component.exports